import styled from 'styled-components'

export const Main = styled.main`
  padding: ${props => props.intro ? '0': '40px 0 80px'};
`;